<template>
  <div class="text-left">
    <h5 v-if="supervisor" class="text-center"><strong>{{ $t("supervisor") }}:</strong> {{ supervisor.username }}</h5>
    <v-divider />
    <v-card class="mt-4 pa-6">
      <DatasetFields :dataset="dataset" :editor-ready="loaded" readonly />
      <v-divider />
      <DirectorActions v-if="isAuthorize" object_type="dataset" class="text-center" />
      <SupervisorActions
        v-else
        :item="dataset"
        object_type="dataset"
        :form_name="formName"
        :state="state"
        :supervisor="supervisor ? supervisor.username : ''"
        @change-state-supervisor="onStateSupervisorChange"
      />
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import DatasetFields from "@/components/datasets/DatasetFields.vue";
import DirectorActions from "@/components/action_buttons/DirectorActions";
import SupervisorActions from "@/components/action_buttons/SupervisorActions";
import { createDefaultDataset, normalizeDataset } from "@/utils/dataset";

export default {
  name: "ReviewDatasetForms",
  components: { DatasetFields, DirectorActions, SupervisorActions },
  data: () => ({ dataset: createDefaultDataset(), formName: "", state: "", supervisor: null, loaded: false }),
  computed: { isAuthorize() { return this.$route.meta.authorize !== undefined; } },
  created() {
    axios.get(`${this.$store.state.endpoint}/moderatedOperations/review/dataset/${this.$route.params.id}`)
      .then(response => {
        this.dataset = normalizeDataset(response.data.data.user.dataset);
        this.formName = response.data.form_name;
        this.state = response.data.state;
        this.supervisor = response.data.supervisor;
      }).catch(error => console.error(error)).finally(() => { this.loaded = true; });
  },
  methods: {
    onStateSupervisorChange(state, supervisor) { this.state = state; this.supervisor = supervisor; }
  }
};
</script>
